<template>
  <div>
    <div class="cart-tag p-3 pb-0">
      <template v-if="cartTag">
        <div @click="copyCartTagToClipboard" class="copy-to-clipboard-button">
          {{ t("CART_TAG") }}:
          <span :title="t('COPY_CART_TAG_TO_CLIPBOARD')">
            {{ cartTag }}
            <i
              class="fa-solid mx-1"
              :class="{
                'fa-copy': !isCartTagCopied,
                'fa-check': isCartTagCopied,
              }"
            ></i>
          </span>
        </div>
        <div
          @click="handleClick"
          v-if="showCancelSaleBtn"
          class="cancel-sale-link"
        >
          <span>{{ t("CANCEL_SALE") }}</span>
        </div>
      </template>
      <!-- Empty placeholder to maintain height when no cart -->
      <div v-else class="cart-tag-placeholder">&nbsp;</div>
    </div>
    <template v-if="cartTag">
      <ConfirmEndOfSaleSelfServiceModal
        v-if="showConfirmEndSaleSelfServiceModal"
        :show="showConfirmEndSaleModal"
        @closeModal="closeModal"
      />

      <ConfirmEndOfSaleModal
        v-else
        :show="showConfirmEndSaleModal"
        @closeModal="closeModal"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import ConfirmEndOfSaleModal from "@/apps/merchant3/components/ConfirmEndOfSaleModal.vue";
import { RoutesPageSteps } from "@/apps/merchant3/router/RoutesPageSteps";
import ConfirmEndOfSaleSelfServiceModal from "@/apps/merchant3/components/ConfirmEndOfSaleSelfServiceModal.vue";
import { isSelfServiceSale } from "@/apps/merchant3/helpers/self-service";
import {
  isEcommerceFlow,
  isDirectToCustomerFlow,
} from "@/apps/merchant3/helpers/checkoutFlows";

const store = useStore();
const { t } = useI18n();
const showConfirmEndSaleModal = ref(false);
const cartTag = computed(() => store.state.carts?.cartTag);

const step = computed(() => {
  return store.state.carts?.step;
});

const EcommerceDownPaymentPending = computed(() => {
  return (
    isEcommerceFlow.value &&
    sessionStorage.getItem("eCommerceDownPaymentStatus") === "pending"
  );
});

const showCancelSaleBtn = computed(() => {
  return (
    step.value !== RoutesPageSteps.Receipt &&
    step.value !== RoutesPageSteps.Welcome &&
    step.value !== RoutesPageSteps.MerchantLogin &&
    step.value !== RoutesPageSteps.ClerkLogin &&
    !EcommerceDownPaymentPending.value &&
    !isDirectToCustomerFlow.value
  );
});

const closeModal = () => {
  showConfirmEndSaleModal.value = false;
};

const handleClick = () => {
  if (
    step.value !== RoutesPageSteps.Receipt &&
    step.value !== RoutesPageSteps.Welcome &&
    step.value !== RoutesPageSteps.MerchantLogin &&
    step.value !== RoutesPageSteps.ClerkLogin
  ) {
    showConfirmEndSaleModal.value = true;
  }
};

const showConfirmEndSaleSelfServiceModal = isSelfServiceSale();

const isCartTagCopied = ref(false);
const copyCartTagToClipboard = async () => {
  await navigator.clipboard.writeText(cartTag.value);
  isCartTagCopied.value = true;
  let updateButton = setTimeout(() => {
    isCartTagCopied.value = false;
    clearTimeout(updateButton);
  }, 2000);
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.cart-tag {
  font-size: 3vw;
  display: flex;
  width: 100%;
  justify-content: space-between;
  background-color: $pj-color-nav-bar-gray;
  padding: 10px 50px 0 50px;
}

.cancel-sale-link {
  display: flex;
  justify-content: flex-end;
  color: $pj-color-green;
  font-weight: bold;
  cursor: pointer;
}

.copy-to-clipboard-button {
  cursor: pointer;
  .fa-copy {
    color: $pj-color-green;
  }
}

.cart-tag-placeholder {
  width: 100%;
}

@media all and (min-width: 400px) {
  .cart-tag {
    font-size: 11pt;
  }
}
</style>
